import { render, staticRenderFns } from "./ItemListMultipleSelectedList.vue?vue&type=template&id=062f12f5"
import script from "./ItemListMultipleSelectedList.vue?vue&type=script&lang=js"
export * from "./ItemListMultipleSelectedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports